import React from 'react';
import { User, MapPin, Layout, Home, Building, Layers, Phone, FileText, Navigation } from 'lucide-react';
import InputField from './common/InputField';

const SocietyFields = ({ handleInputChange, errors = {} }) => {
    return (
        <>
            <InputField
                label="Society Name"
                name="societyName"
                placeholder="Enter society name"
                icon={User}
                required
                error={errors.societyName}
                onChange={handleInputChange}
            />

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Pincode"
                    name="pincode"
                    type="number"
                    placeholder="e.g. 400050"
                    icon={MapPin}
                    required
                    error={errors.pincode}
                    onChange={handleInputChange}
                />

                <InputField
                    label="Plot Area (sq. metre)"
                    name="plotArea"
                    type="number"
                    placeholder="Area in sq.m"
                    icon={Layout}
                    onChange={handleInputChange}
                />
            </div>

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Members Occupied Area"
                    name="occupiedArea"
                    type="number"
                    placeholder="Area"
                    icon={Home}
                    onChange={handleInputChange}
                />

                <InputField
                    label="Total Number of Flats"
                    name="totalFlats"
                    type="number"
                    placeholder="Number of flats"
                    icon={Home}
                    onChange={handleInputChange}
                />
            </div>

            <InputField
                label="Plot Details (CTS/CS/Plot No.)"
                name="plotDetails"
                placeholder="Enter plot details"
                icon={FileText}
                onChange={handleInputChange}
            />

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Division"
                    name="division"
                    placeholder="e.g. Andheri, Khar"
                    icon={MapPin}
                    required
                    error={errors.division}
                    onChange={handleInputChange}
                />
                <InputField
                    label="Ward"
                    name="ward"
                    placeholder="e.g. HE, HW"
                    icon={Navigation}
                    onChange={handleInputChange}
                />
            </div>

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Total Buildings"
                    name="totalBuildings"
                    type="number"
                    placeholder="Count"
                    icon={Building}
                    onChange={handleInputChange}
                />

                <InputField
                    label="Floors per Building"
                    name="floorsPerBuilding"
                    type="number"
                    placeholder="Avg floors"
                    icon={Layers}
                    onChange={handleInputChange}
                />
            </div>

            <InputField
                label="Contact Number"
                name="contact"
                type="tel"
                placeholder="Mobile / Landline"
                icon={Phone}
                required
                error={errors.contact}
                onChange={handleInputChange}
            />
        </>
    );
};

export default SocietyFields;


